import { logger } from '@modules/logger';
import { createContext } from 'react';

const initialContext = {
  activeId: undefined,
  mode: undefined,
  requestToMakeActive: () => logger.warn('requestToMakeActive not provided for cardFieldEditContext'),
  makeInactive: () => logger.warn('makeInactive not provided for cardFieldEditContext'),
};

interface cardFieldEditContextValues {
  activeId?: string;
  mode?: 'create' | 'update';
  requestToMakeActive: (id: string, mode: 'create' | 'update') => void;
  makeInactive: (id: string) => void;
}
const cardFieldEditContext = createContext<cardFieldEditContextValues>(initialContext);

export { cardFieldEditContext };
